/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect } from "react";
import { useToggle } from "react-use";
import { SubmitHandler, useForm } from "react-hook-form";

import { DataHeader, Flex, Grid } from "@payping/web-components";
import { SDKDateObject, dateFormats, toUtc } from "@payping/utils/dateUtils";
// import { PhRDownloadSimple } from "@payping/icons";

// import { sdkFetch, uploadV2Apis } from "@payping/api";
// import { DownloadTypes } from "@/components/DashReport/AppSubNav/Download";

import { FiltersButton } from "@/components/Dataheader/FiltersButton";
import { FiltersDrawer } from "@/components/Dataheader/FiltersDrawer";
import { /* excelDownloadId, pdfDownloadId, */ searchId } from "@/assets/googleTrackIds";

import useTranslator from "@/shared/translate/translator";
import { RHFDateRangePicker, RHFInputSearch, RHFSelect } from "@/shared/components";
import { DefaultOptionType } from "@payping/web-components/components/Select/types";
import { RefundOperationStateEnum } from "@/refund/repository/refund/v1/refund-v1-api";
import type { QueryStatesSetter, RefundFilterQueryParams } from "@/refund/domains/filter.domain";

interface Props {
  queryParams: RefundFilterQueryParams;
  setQueryParams: QueryStatesSetter<RefundFilterQueryParams>;
}

interface FormValues {
  rangePicker?: SDKDateObject[];
  searchVariant?: any;
  searchValue?: any;
  states: number | null;
}

const RefundTransactionFilter: FC<Props> = ({ queryParams, setQueryParams }) => {
  const { t: generalT } = useTranslator();
  const { t } = useTranslator("refund.transactions.filters");
  const { xl } = Grid.useBreakpoint();

  const [openDrawer, toggleDrawer] = useToggle(false);
  const backFormat = dateFormats.standard.utcDate;
  const { fromDate, toDate, states, paymentCodes, minAmount, maxAmount, pan } = queryParams;

  const initialRangePicker = () => {
    const value: SDKDateObject[] = [];
    if (fromDate) {
      value[0] = toUtc({
        convertTime: false,
        date: fromDate,
        dateFormat: dateFormats.standard.utcDateTime,
      }).object as SDKDateObject;
    }
    if (toDate) {
      value[1] = toUtc({
        convertTime: false,
        date: toDate,
        dateFormat: dateFormats.standard.utcDateTime,
      }).object as SDKDateObject;
    }
    return value;
  };
  const initialSearchVariant = () => {
    if (paymentCodes) return "paymentCodes";
    if (minAmount) return "minAmount";
    if (maxAmount) return "maxAmount";
    if (pan) return "pan";
    return "searchByType";
  };
  const initialSearchValue = () => paymentCodes || minAmount || maxAmount || pan || "searchByType";

  const { control, handleSubmit, watch, setValue, reset } = useForm<FormValues>({
    defaultValues: {
      rangePicker: initialRangePicker(),
      states,
      searchVariant: initialSearchVariant(),
      searchValue: initialSearchValue(),
    },
  });

  const variants: Record<string, any> = {
    paymentCodes: "",
    minAmount: null,
    maxAmount: null,
    pan: "",
  };
  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    const [from, to] =
      data.rangePicker && data.rangePicker.length
        ? [data.rangePicker[0]?.format(backFormat), data.rangePicker[1]?.format(backFormat)]
        : ["", ""];

    setQueryParams((prev) => ({
      ...prev,
      ...variants,
      pageNumber: 1,
      fromDate: from,
      toDate: to,
      states: data.states === 0 ? null : data.states,
      [data.searchVariant]: data.searchValue || variants[data.searchVariant],
    }));
  };

  const searchVariantValue = watch("searchVariant");
  const searchVariantOptions: DefaultOptionType[] = [
    { value: "searchByType", label: generalT("report.searchBy"), disabled: true },
    { value: "paymentCodes", label: t("paymentCodes") },
    { value: "minAmount", label: t("minAmount") },
    { value: "maxAmount", label: t("maxAmount") },
    { value: "pan", label: t("pan") },
  ];
  const searchValue = watch("searchValue");
  const searchValueDisabled = searchVariantValue === "searchByType";

  useEffect(() => {
    if (searchVariantValue) {
      setValue("searchValue", "");
    }
  }, [searchVariantValue, setValue]);

  // -----------------------search bar----------------------------//
  const renderSearchbarInput = (
    <RHFInputSearch
      name="searchValue"
      control={control}
      onSearch={handleSubmit(onSubmit)}
      allowClear
      placeholder={t("searchValue")}
      data-google-track={searchId}
      disabled={searchValueDisabled}
      addonBefore={
        <RHFSelect
          name="searchVariant"
          control={control}
          dropdownMatchSelectWidth={false}
          options={searchVariantOptions}
          noErrorMessage
        />
      }
    />
  );

  // -----------------------download btn----------------------------//
  // const handleDownload = useCallback(
  //   async (type: DownloadTypes, newWindow: Window | null): Promise<void> => {
  //     const body = {
  //       amount,
  //       cardNumber,
  //       clientId,
  //       clientRefId,
  //       code,
  //       fromDate,
  //       ipgRefId,
  //       payerName,
  //       payerPhoneNumber,
  //       paymentStatus,
  //       paymentType,
  //       refId,
  //       toDate,
  //     };
  //     let url;
  //     if (type === "Excel") {
  //       const response = await sdkFetch("/v2/upload/PaymentsExcelExport", {
  //         body: JSON.stringify(body),
  //         method: "POST",
  //       });
  //       url = await response.text();
  //     } else {
  //       // @ts-expect-error paymentType
  //       url = await uploadV2Apis.paymentsPdfExportWithModelPost(body);
  //     }
  //     newWindow?.location?.assign?.(url);
  //   },
  //   [
  //     amount,
  //     cardNumber,
  //     clientId,
  //     clientRefId,
  //     code,
  //     fromDate,
  //     ipgRefId,
  //     payerName,
  //     payerPhoneNumber,
  //     paymentStatus,
  //     paymentType,
  //     refId,
  //     toDate,
  //   ],
  // );
  // const downloadFileItems = [
  //   {
  //     key: "1",
  //     label: <span data-google-track={excelDownloadId}>{generalT("downloadExcel")}</span>,
  //     onClick: () => {
  //       const newWindow = window.open(undefined, "_blank");
  //       // handleDownload("Excel", newWindow);
  //     },
  //   },
  //   {
  //     key: "2",
  //     label: <span data-google-track={pdfDownloadId}>{generalT("downloadPdf")}</span>,
  //     onClick: () => {
  //       const newWindow = window.open(undefined, "_blank");
  //       // handleDownload("PDF", newWindow);
  //     },
  //   },
  // ];
  // const renderDownloadButton = (
  //   <Dropdown
  //     menu={{
  //       items: downloadFileItems,
  //     }}
  //   >
  //     <Button block icon={PhRDownloadSimple}>
  //       {generalT("downloadFile")}
  //     </Button>
  //   </Dropdown>
  // );

  // -----------------------filter btn----------------------------//
  const mobileFiltersBadgeCount = !xl && searchVariantValue && searchValue ? { [searchVariantValue]: searchValue } : {};
  const params = { states };
  const statesOptions: DefaultOptionType[] = [
    { value: 0, label: t("state.all") },
    { value: RefundOperationStateEnum.Created, label: t("state.created") },
    { value: RefundOperationStateEnum.PendingBlockage, label: t("state.pendingBlockage") },
    { value: RefundOperationStateEnum.PreparedToProcess, label: t("state.preparedToProcess") },
    { value: RefundOperationStateEnum.ProcessingRefund, label: t("state.processingRefund") },
    { value: RefundOperationStateEnum.RefundFailed, label: t("state.refundFailed") },
    { value: RefundOperationStateEnum.RefundSucceeded, label: t("state.refundSucceeded") },
    { value: RefundOperationStateEnum.Cancelled, label: t("state.cancelled") },
  ];
  const onClickApplyFilters = () => {
    handleSubmit(onSubmit)();
    toggleDrawer(false);
  };
  const onClickResetFilters = () => {
    reset({
      rangePicker: undefined,
      states: null,
      searchVariant: "",
      searchValue: "",
    });
    handleSubmit(onSubmit)();
    toggleDrawer(false);
  };

  const renderFiltersButton = (
    <>
      <FiltersButton onClick={() => toggleDrawer(true)} params={{ ...params, ...mobileFiltersBadgeCount }} />

      <FiltersDrawer
        title={t("title")}
        onClose={() => toggleDrawer(false)}
        open={openDrawer}
        loading={false}
        onClickApplyFilters={onClickApplyFilters}
        onClickResetFilters={onClickResetFilters}
      >
        <Flex vertical gap={8}>
          {!xl ? renderSearchbarInput : null}

          <RHFSelect name="states" control={control} options={statesOptions} allowClear label={t("state.title")} />
        </Flex>
      </FiltersDrawer>
    </>
  );

  return (
    <DataHeader
      filters={{
        datepickerInput: (
          <RHFDateRangePicker name="rangePicker" control={control} className={"w-100 tw-m-0"} allowClear />
        ),
        searchbarInput: xl ? renderSearchbarInput : null,
        filtersButton: renderFiltersButton,
        // downloadButton: renderDownloadButton,
      }}
    />
  );
};
export default RefundTransactionFilter;
